<template>
  <div class="index-stock full-height">
    <div class="bg-white p-y-15 p-x-24 border-radius-12 full-height">
      <div class="font-14 flex-s-0 m-b-24">供应链栏</div>
      <!-- 循环体 -->
      <tk-flex
        middle
        :key="index"
        v-for="(item, index) in cardList"
        class="card-item bg-white border-radius-12"
        @click.native="item.path ? $router.push(item.path) : ''"
      >
        <tk-flex class="fill" middle >
          <tk-flex middle center class="card-icon m-r-16 unshrink" :style="{ background: item.bg }" >
            <tk-icon :size="28" :color="item.color">{{ item.icon }}</tk-icon>
          </tk-flex>
          <tk-flex column middle class="fill">
            <div class="font-12 wordBreak-lineHeight" style="color: #84888F" >{{ item.title }}</div>
            <div class="font-20 font-bold m-t-5 wordBreak-lineHeight" >{{ item.num }}</div>
          </tk-flex>
        </tk-flex>
        <tk-flex middle center class="m-l-10 unshrink" style="width: 22px;height: 22px;background-color: #F7FAFF;border-radius: 50%;"  >
          <tk-icon :size="8" :color="item.color">rightarrowbold</tk-icon>
        </tk-flex>
      </tk-flex>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      cardList: [
        {
          name: 'warehouse',
          bg: '#ECFBFF',
          color: '#00D0FE',
          icon: 'agent',
          title: '代理商仓库库存',
          num: 0,
          path: '/model/agentWarehouseStock'
        },
        {
          name: 'distribution',
          bg: '#FFEDE1',
          color: '#FF9551',
          icon: 'a-instock',
          title: '门店铺货库存',
          num: 0,
          path: '/distributionStock'
        },
        {
          name: 'replenishment',
          bg: '#EAFDFB',
          color: '#65D0BD',
          icon: 'data',
          title: '今日补货数据',
          num: 0,
          path: '/model/todayOrder'
        }
      ]
    }
  },
  computed: {
    ...mapState(['user'])
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      try {
        await Promise.all([this.getWarehouse(), this.getDistribution(), this.getReplenishment()])
      } catch (error) {
        console.log(error)
      }
    },
    // 获取按战区/大区统计仓库库存
    async getWarehouse () {
      let where = { isDelete: false }
      if (this.$store.state.user.level === '4' || this.$store.state.user.level === '3') {
        // 增加一个查询条件，仅查询代理商下的订单
        where.agent = this.$store.state.user.level === '3' ? this.$store.state.user.objectId : this.$store.state.user.agent
      }
      if (this.$store.state.user.level === '2') {
        // 增加一个查询条件，仅查询大区下的订单
        where.regional = this.$store.state.user.department
      }
      if (this.$store.state.user.level === '1') {
        // 增加一个查询条件，仅查询战区下的订单
        where.warZone = this.$store.state.user.department
      }
      let { data: res } = await this.$tkParse.get('/aggregate/warehouseStock', {
        params: {
          group: {
            objectId: '',
            total: {
              $sum: '$num'
            }
          },
          match: {
            ...where
          }
        }
      })
      console.log('🚀 ~ file: supply.vue:91 ~ getWarehouse ~ res:', res)
      this.cardList[0].num = res.results && res.results.length ? res.results[0].total || 0 : 0
    },
    // 获取按战区/大区统计铺货库存
    async getDistribution () {
      let where = { isDelete: false }
      if (this.$store.state.user.level === '4' || this.$store.state.user.level === '3') {
        // 增加一个查询条件，仅查询代理商下的订单
        where.agent = this.$store.state.user.level === '3' ? this.$store.state.user.objectId : this.$store.state.user.agent
      }
      if (this.$store.state.user.level === '2') {
        // 增加一个查询条件，仅查询大区下的订单
        where.regional = this.$store.state.user.department
      }
      if (this.$store.state.user.level === '1') {
        // 增加一个查询条件，仅查询战区下的订单
        where.warZone = this.$store.state.user.department
      }
      let { data: res } = await this.$tkParse.get('/aggregate/distributionStock', {
        params: {
          group: {
            objectId: '',
            total: {
              $sum: '$stockNum'
            }
          },
          match: {
            ...where
            // ...this.user.adminRole === 'staff' ? { warZone: this.user.department } : {}
          }
        }
      })
      // console.log('🚀 ~ file: stock.vue:147 ~ getInStock ~ res', res.results)
      this.cardList[1].num = res.results && res.results.length ? res.results[0].total || 0 : 0
    },
    /// 获取战区/大区完成订单
    async getReplenishment () {
      // 获取服务器时间
      let date = await this.$tkParse.get('https://api.mokekeji.com/time')
      // 根据时间获取当天的开始时间和结束时间
      let s = new Date(new Date(date.data).setHours(0, 0, 0, 0)).toISOString()
      let e = new Date(new Date(date.data).setHours(23, 59, 59, 999)).toISOString()

      let where = {
        status: '2',
        finishTime: {
          $gte: s,
          $lte: e
        }
      }

      if (this.$store.state.user.level === '4' || this.$store.state.user.level === '3') {
        // 增加一个查询条件，仅查询代理商下的订单
        where.agent = this.$store.state.user.level === '3' ? this.$store.state.user.objectId : this.$store.state.user.agent
      }
      if (this.$store.state.user.level === '2') {
        // 增加一个查询条件，仅查询大区下的订单
        where.regional = this.$store.state.user.department
      }
      if (this.$store.state.user.level === '1') {
        // 增加一个查询条件，仅查询战区下的订单
        where.warZone = this.$store.state.user.department
      }

      let { data: res } = await this.$tkParse.get('/aggregate/order', {
        params: {
          group: {
            objectId: '',
            total: {
              $sum: 1
            }
          },
          match: {
            ...where
            // ...this.user.adminRole === 'staff' ? { warZone: this.user.department } : {}
          }
        }
      })
      // console.log('🚀 ~ file: stock.vue:147 ~ getInStock ~ res', res.results)
      this.cardList[2].num = res.results && res.results.length ? res.results[0].total || 0 : 0
    }
  }
}
</script>
<style scoped lang="scss">
.a {
  color: #FF6161;
}
.card-icon {
  width: 44px;
  height: 44px;
  border-radius: 22px;
  flex-shrink: 0;
}
.card-item {
  height: 100px;
  flex: 1;
  box-sizing: border-box;
  cursor: pointer;
}
.wordBreak-lineHeight{
  word-break: break-all;
  line-height: 1;
}
</style>
